import type {
  ArticleListResponse,
  Category,
  CategoryListResponseDataItemCustom,
  ResolvedCategory,
} from '@twisto/api-cms'

import { PopularArticleList } from '../../components'

import { MainCategoryHeader } from './main-category-header'
import * as styles from './main-category-overview.styles'
import { Subcategories } from './subcategories'

type Props = {
  category: CategoryListResponseDataItemCustom['attributes']
  popularArticles?: ArticleListResponse
}

export const MainCategoryOverview = ({ category, popularArticles }: Props) => (
  <>
    <MainCategoryHeader category={category} />
    <main css={styles.main}>
      {category.categories?.map((subcategory: Category) => (
        <Subcategories
          key={subcategory.name}
          {...(subcategory as ResolvedCategory)}
        />
      ))}
    </main>
    <PopularArticleList articles={popularArticles} />
  </>
)
